/** Field names that hold PAN numbers — not editable after onboarding. */
export const PAN_NUMBER_FIELD_NAMES = new Set([
  "panNumber",
  "panCardNumber",
  "CompanypanNumber",
  "directorPANNumber",
  "panOfTrustNumber",
  "panOfTrusteeNumber",
  // "gstNumber",
]);

export const isPanNumberField = (fieldName) =>
  !!fieldName && PAN_NUMBER_FIELD_NAMES.has(fieldName);
